"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addTrack = void 0;
const contains_1 = __importDefault(require("ramda/src/contains"));
const routeIds_1 = require("root/src/shared/descriptions/routes/routeIds");
function addTrack(event, data = null) {
    // eslint-disable-next-line no-undef
    // @ts-ignore
    if (!FACEBOOK_PIXEL_ID)
        return;
    window.fbq('track', event, data);
}
exports.addTrack = addTrack;
function facebookPixel(routeId) {
    if ((0, contains_1.default)('ROUTE_MOCK_', routeId))
        return;
    switch (routeId) {
        case routeIds_1.VIEW_PROJECT_ROUTE_ID:
            addTrack('ViewContent');
            break;
        case routeIds_1.VIEW_CREATOR_DATA_ROUTE_ID:
            addTrack('ViewContent');
            break;
        default:
    }
}
exports.default = facebookPixel;
